export function defaultForexAccount(categoryId: string | undefined, connectionId: string | undefined): string {
  return connectionId && categoryId?.startsWith(`${connectionId}.`) ? categoryId : '';
}
